// For premium/basic label status: { text: 'Premium', color: '#000', bgColor: '#ffaa00' } --> declare this in the resume

// import { resumeTemplates } from '../drive/content/tabs/templatesTab/resumesDictionary';

// import { coverLetterTemplates } from '../drive/content/tabs/templatesTab/coverLetterTemplates';
import { coverLetterTemplates } from '../../../../cra/src/components/drive/content/tabs/templatesTab/coverLettersDictionary';
import { resumeTemplates } from '../../../../cra/src/components/drive/content/tabs/templatesTab/resumesDictionary';

export default {
  GROUP1: {
    tabs: [
      {
        category: 'resumes',
        text: 'Resume',
        link: '/resume-templates',
      },
      {
        category: 'coverLetters',
        text: 'Cover Letter',
        link: '/cover-letter-templates',
      },
    ],

    sideTabContent: '12 color themes available!',

    content: {
      resumes: {
        text: 'Resume',
        heading: 'Resume Templates',
        description:
          'An attractive and beautiful resume is all you need for receiving a call from recruiters. Create a master resume and export as any template, color, or content as needed for specific role.',
        templates: [
          resumeTemplates.Attractive,
          resumeTemplates.Agricultural,
          resumeTemplates.Basic,
          resumeTemplates.Businessmajor,
          resumeTemplates.Elegant,
          resumeTemplates.Emblem,
          resumeTemplates.Exemplary,
          resumeTemplates.Functional,
          resumeTemplates.Gradient,
          resumeTemplates.Inventor,
          resumeTemplates.Nineties,
          resumeTemplates.Simple,
          resumeTemplates.Vintage,
          resumeTemplates.Geospatial,
          resumeTemplates.Techie,
          resumeTemplates.Falcon,
          resumeTemplates.Proxima,
          resumeTemplates.Orion,
          resumeTemplates.Streak,
          resumeTemplates.Stellar,
        ],
      },
      coverLetters: {
        text: 'Cover Letter',
        heading: 'Cover Letter Templates',
        description:
          'Resumes may show your skills and experience in getting a job, but cover letters are equally important as they describe your personality and the interest towards every job you apply and immediately puts you ahead of the curve.',
        templates: [
          coverLetterTemplates.Attractive,
          coverLetterTemplates.Basic,
          coverLetterTemplates.Elegant,
          coverLetterTemplates.Emblem,
          coverLetterTemplates.Exemplary,
          coverLetterTemplates.Gradient,
          coverLetterTemplates.Inventor,
          coverLetterTemplates.Nineties,
          coverLetterTemplates.Simple,
          coverLetterTemplates.Vintage,
        ],
      },
    },

    adContent: {
      heading: 'Beautiful templates, Easy to use, and Freakishly smart',
      description: null,
    },
  },
};
